export const transformNumber = (number) => {
    const numberFormmated = new Intl.NumberFormat('es-MX', { style: 'decimal', notation: 'standard', maximumFractionDigits: 2 }).format(number).replace(',', '');
    return numberFormmated
}